'use client';

import { useDataLayerEventOnPageLoad } from '@coolblue-development/next-analytics/client';
import { PageType } from '@sharedTypes';

type Props = {
  vacancyTitle: string;
  pageType: PageType;
  vacancyId: string;
};

export const VacancyAnalyticsConfig = ({ vacancyTitle, pageType, vacancyId }: Props) => {
  const event = [
    {
      vacancyTitle: vacancyTitle,
      pagetype: pageType,
      cbVacancyID: vacancyId,
      postingID: vacancyId //TODO: Replace with ATS ID
    }
  ];

  useDataLayerEventOnPageLoad(event);

  return <></>;
};
